import { render, staticRenderFns } from "./Home_v2.vue?vue&type=template&id=39780889&"
import script from "./Home_v2.vue?vue&type=script&lang=js&"
export * from "./Home_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports